import { render } from "./Occupational.vue?vue&type=template&id=4542dfab"
import script from "./Occupational.vue?vue&type=script&lang=js"
export * from "./Occupational.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__